import NewMessages from "./NewMessages"

const Dialogs  = {
    NewMessages
}
export default Dialogs;